import Repository from "./Repository";
import store from "../store";

const resource = "/SupplierGoodsStock";

export default {
  loadSupplierProducts(categoryId, supplierId) {
    return Repository.post(
      `${resource}/load-supplier-products/${supplierId}/${categoryId}`
    ).then((response) => {
      if (response.data.status === "success") {
        store.commit("setSnack", {
          message: "Задача по загрузке товаров поставлена в очередь",
          color: "success",
        });
      }
      return response;
    });
  },
  checkLoadProductsStatus(categoryId) {
    return Repository.post(
      `${resource}/check-load-products-status/${categoryId}`
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getCategoryGoods(categoryId) {
    return Repository.get(`${resource}/goods-list/${categoryId}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  publishGoods(categoryId, products, allProductsIsNew) {
    return Repository.post(
      `${resource}/publish-goods/${categoryId}/${allProductsIsNew}`,
      products
    )
      .then((response) => {
        if (response && response.data.status === "success") {
          store.commit("setSnack", {
            message: "Товары успешно опубликованы",
            color: "success",
          });
        }
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getCategoryGoodsWithSimilars(categoryId, subcategories) {
    const params = new URLSearchParams();
    subcategories.forEach(id => params.append("subcategoryIds", id));
    return Repository.get(`${resource}/list-with-similars/${categoryId}?${params.toString()}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  searchByWord(categoryId, productId, searchTerm) {
    const params = new URLSearchParams();
    params.append("categoryId", categoryId);
    params.append("productId", productId);
    params.append("searchTerm", searchTerm);
    return Repository.get(`${resource}/search-by-word/?${params.toString()}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
